import {
  eyeIcon,
} from "@excalidraw/excalidraw/components/icons";
import { MainMenu } from "@excalidraw/excalidraw/index";
import React from "react";

import { isDevEnv } from "@excalidraw/common";

import type { Theme } from "@excalidraw/element/types";

import { LanguageList } from "../app-language/LanguageList";

import { saveDebugState } from "./DebugCanvas";

export const AppMainMenu: React.FC<{
  onCollabDialogOpen: () => any;
  isCollaborating: boolean;
  isCollabEnabled: boolean;
  theme: Theme | "system";
  setTheme: (theme: Theme | "system") => void;
  refresh: () => void;
  onOpenDrawings?: () => void;
  onNewDrawing?: () => void;
  onSaveAs?: () => void;
  onOpenLibraryBrowser?: () => void;
  userName?: string;
  onSignOut?: () => void;
}> = React.memo((props) => {
  return (
    <MainMenu>
      <MainMenu.DefaultItems.LoadScene />
      <MainMenu.DefaultItems.SaveToActiveFile />
      <MainMenu.DefaultItems.Export />
      <MainMenu.DefaultItems.SaveAsImage />
      {props.isCollabEnabled && (
        <MainMenu.DefaultItems.LiveCollaborationTrigger
          isCollaborating={props.isCollaborating}
          onSelect={() => props.onCollabDialogOpen()}
        />
      )}
      <MainMenu.Separator />
      {props.onOpenDrawings && (
        <MainMenu.Item onSelect={props.onOpenDrawings}>
          My Drawings
        </MainMenu.Item>
      )}
      {props.onNewDrawing && (
        <MainMenu.Item onSelect={props.onNewDrawing}>
          New Drawing
        </MainMenu.Item>
      )}
      {props.onSaveAs && (
        <MainMenu.Item onSelect={props.onSaveAs}>
          Save As...
        </MainMenu.Item>
      )}
      {props.onOpenLibraryBrowser && (
        <MainMenu.Item onSelect={props.onOpenLibraryBrowser}>
          Architecture Libraries
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.CommandPalette className="highlighted" />
      <MainMenu.DefaultItems.SearchMenu />
      <MainMenu.DefaultItems.Help />
      <MainMenu.DefaultItems.ClearCanvas />
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Socials />
      {isDevEnv() && (
        <MainMenu.Item
          icon={eyeIcon}
          onSelect={() => {
            if (window.visualDebug) {
              delete window.visualDebug;
              saveDebugState({ enabled: false });
            } else {
              window.visualDebug = { data: [] };
              saveDebugState({ enabled: true });
            }
            props?.refresh();
          }}
        >
          Visual Debug
        </MainMenu.Item>
      )}
      <MainMenu.Separator />
      <MainMenu.DefaultItems.Preferences />
      <MainMenu.DefaultItems.ToggleTheme
        allowSystemTheme
        theme={props.theme}
        onSelect={props.setTheme}
      />
      <MainMenu.ItemCustom>
        <LanguageList style={{ width: "100%" }} />
      </MainMenu.ItemCustom>
      <MainMenu.DefaultItems.ChangeCanvasBackground />
      {props.userName && (
        <>
          <MainMenu.Separator />
          <MainMenu.ItemCustom>
            <div
              style={{
                padding: "0 12px",
                fontSize: "12px",
                color: "var(--color-text-secondary, #999)",
              }}
            >
              Signed in as {props.userName}
            </div>
          </MainMenu.ItemCustom>
          {props.onSignOut && (
            <MainMenu.Item onSelect={props.onSignOut}>Sign out</MainMenu.Item>
          )}
        </>
      )}
    </MainMenu>
  );
});
